import { memo, MutableRefObject, useEffect, useState } from "react";
import {
  Grid,
  Icon,
  Input,
  Popup,
  Ref,
  InputOnChangeData,
} from "semantic-ui-react";
import FetchAPI from "../../../../../api/FetchAPI";
import { toastError } from "../../../../../app_shared_functions";
import { NameServerResponse } from "../../../../../api/resources/Networking/NamesServer";

type DNSProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
  ipVersion: number;
  dnsNameservers: string;
  dnsRef: MutableRefObject<HTMLElement | null>;
  region: string;
  errorClassName: string;
};

const DNS = ({
  onChange,
  ipVersion,
  dnsNameservers,
  dnsRef,
  region,
  errorClassName,
}: DNSProps) => {
  const [nameServers, setNameServers] = useState<NameServerResponse>({});

  // Fetch data [only] on mount. No need to refetch upon region update
  useEffect(() => {
    FetchAPI.Networking.NamesServer.getList()
      .then((response) => {
        setNameServers(response?.data);
      })
      .catch((error) => {
        toastError(error, "Error fetching default nameservers");
      });
  }, []);

  useEffect(() => {
    if (region && ipVersion && nameServers?.[region]) {
      const defaultValue =
        nameServers[region][`ipv${ipVersion}` as "ipv4" | "ipv6"]?.join(", ") ||
        "";

      onChange(
        {} as React.FormEvent<HTMLInputElement>,
        { name: "dnsNameservers", value: defaultValue } as InputOnChangeData,
      );
    }
  }, [ipVersion, onChange, region, nameServers]);

  return (
    <Grid.Row className="separator separator--simple margin-top margin-bottom">
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top"
      >
        <h5>
          DNS name servers
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Format example :{" "}
            {ipVersion === 4
              ? "8.8.8.8, 8.8.8.4"
              : "2001:4860:4860::8888, 2001:4860:4860::8844"}
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top"
      >
        <Ref innerRef={dnsRef}>
          <Input
            value={dnsNameservers}
            className={`select-box full ${errorClassName}`}
            name="dnsNameservers"
            onChange={onChange}
          />
        </Ref>
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(DNS);
